import React from 'react';
import ReactDOM from 'react-dom/client';
import 'leaflet/dist/leaflet.css';
import { setDefaultOptions } from 'date-fns/setDefaultOptions';
import { ptBR } from 'date-fns/locale';

import App from './App.tsx';
import './global.css';

setDefaultOptions({ locale: ptBR });

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
